import styled, { css } from 'styled-components';

import { HorizontalCenterBlock } from '../../../styled';
import { LinkStyles } from '../../ui';

export const CardWrapper = styled.div<{ selected: boolean }>`
  background: ${(p) => p.theme.colors.tableCell};
  border: 1px solid ${(p) => p.theme.colors.stroke};
  box-sizing: border-box;
  border-radius: 6px;
  padding: 33px;
  height: 666px;
  align-items: initial;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${(p) => p.selected && SelectWrapper}
`;

export const BottomWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TextWrapper = styled.div`
  margin-bottom: 32px;
`;

export const ImageWrapper = styled(HorizontalCenterBlock)`
  margin-bottom: 32px;
`;

const SelectWrapper = css`
  border: 2px solid ${(p) => p.theme.colors.action};
  padding: 32px;
`;

export const DocWrapper = styled(LinkStyles)`
  margin-top: 8px;
`;

export const Title = styled.div`
  ${(p) => p.theme.typography.title2compact};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const Description = styled.div`
  margin-top: 8px;
  overflow: hidden;
  max-height: 96px;
  ${(p) => p.theme.typography.description};
  color: ${(p) => p.theme.colors.muted};
`;

export const Text = styled.div`
  ${(p) => p.theme.typography.subHeader};
`;
